import React from "react";
import { Container, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AiOutlineInstagram } from "react-icons/ai";
import { RiFacebookLine,RiTwitterLine } from "react-icons/ri";
import "./SubHeader.css";
const SubHeader = () => {
  return (
    <div className="sub-header">
      <Container>
        <div className="sub-header-container">
          <div className="row align-items-center">
            <div className="col-5">
              <div className="d-flex align-items-center">
                <div className="icon-box">
                  <RiFacebookLine />
                </div>
                <div className="icon-box ms-2">
                  <AiOutlineInstagram />
                </div>
                <div className="icon-box ms-2">
                  <RiTwitterLine />
                </div>
              </div>
            </div>
            <div className="col-7 d-flex align-items-center justify-content-end">
              <ul className="sub-header-link-container">
                {/* <li><Link className='d-flex align-items-center' to="#"><span className='lg-screen'>Language</span></Link></li> */}
                <li>
                  <Form.Select className="border-0 language-select" aria-label="Default select example">
                    <option>Language</option>
                    <option value="1">English</option>
                    <option value="2">Bangla</option>
                    <option value="3">Another</option>
                  </Form.Select>
                </li>
                <li>
                  <Link className="d-flex align-items-center" to="/login">
                    <span>Logout</span>
                  </Link>
                </li>
                {/* <li><Link className='d-flex align-items-center' to="/profile"><div className='profile-icon'><img src={require('../../../images/users/user3.png')} className='h-100 w-100' alt="" /></div></Link></li> */}
              </ul>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default SubHeader;
